<!-- =========================================================================================
  File Name: AddNewDataSidebar.vue
  Description: Add New Data - Sidebar component
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
  <vs-sidebar click-not-close position-right parent="body" default-index="1" color="primary" class="add-new-data-sidebar items-no-padding" spacer v-model="isSidebarActiveLocal">
    <div class="mt-6 flex items-center justify-between px-6">
        <h4>{{ Object.entries(this.data).length === 0 ? "ADD NEW" : "ADD NEW" }} TAG</h4>
        <feather-icon icon="XIcon" @click.stop="isSidebarActiveLocal = false" class="cursor-pointer"></feather-icon>
    </div>
    <vs-divider class="mb-0"></vs-divider>

    <component :is="scrollbarTag" class="scroll-area--data-list-add-new" :settings="settings" :key="$vs.rtl">

      <div class="p-6">

        <!-- <template v-if="dataImg">

          <div class="img-container w-64 mx-auto flex items-center justify-center">
            <img :src="dataImg" alt="img" class="responsive">
          </div>

          <div class="modify-img flex justify-between mt-5">
            <input type="file" class="hidden" ref="updateImgInput" @change="updateCurrImg" accept="image/*">
            <vs-button class="mr-4" type="flat" @click="$refs.updateImgInput.click()">Update Image</vs-button>
            <vs-button type="flat" color="#999" @click="dataImg = null">Remove Image</vs-button>
          </div>
        </template> -->

        <!-- NAME -->
        <vs-input label="Name" v-model="dataTag" class="mt-5 w-full" name="item-name" v-validate="'required'" maxlength="100"/>
        <span class="text-danger text-sm" v-show="errors.has('item-name')">{{ errors.first('item-name') }}</span>
        </div>
    </component>

    <div class="flex flex-wrap items-center p-6" slot="footer">
      <vs-button class="mr-6" @click.native="submitData" :disabled="!isFormValid">Submit</vs-button>
      <vs-button type="border" color="danger" @click.native="isSidebarActiveLocal = false">Cancel</vs-button>
    </div>
  </vs-sidebar>
</template>

<script>
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import {ADD_TEMPLATE_TAG} from '@/graphql'

export default {
  props: {
    isSidebarActive: {
      type: Boolean,
      required: true
    },
    data: {
      type: Object,
      default: () => {}
    }
  },
  components: {
    VuePerfectScrollbar
  },
  data () {
    return {

      dataId: null,
      dataTag:null,
      settings: { // perfectscrollbar settings
        maxScrollbarLength: 60,
        wheelSpeed: .60
      }
    }
  },
  watch: {
    isSidebarActive (val) {
      if (!val) return
      if (Object.entries(this.data).length === 0) {
        this.$validator.reset()
      } else {
        const {id} = JSON.parse(JSON.stringify(this.data))
        this.dataId = id
      }
      // Object.entries(this.data).length === 0 ? this.initValues() : { this.dataId, this.dataName, this.dataCategory, this.dataOrder_status, this.dataPrice } = JSON.parse(JSON.stringify(this.data))
    }
  },
  computed: {
    isSidebarActiveLocal: {
      get () {
        return this.isSidebarActive
      },
      set (val) {
        if (!val) {
          this.$emit('closeSidebar')
          this.dataTag=null
          this.$validator.reset()
          // this.$validator.reset()
          // this.initValues()
        }
      }
    },
    isFormValid () {
      return !this.errors.any() && this.dataTag
    },
    scrollbarTag () { return this.$store.getters.scrollbarTag }
  },
  methods: {
    StatusSuccess () {
      this.$vs.notify({
        title: 'Newsletter',
        text: 'Add Successfully',
        color: 'success',
        position: 'top-right'
      })
    },
    StatusFail () {
      this.$vs.notify({
        title: 'Newsletter',
        text: 'Failed to add',
        color: 'success',
        position: 'top-right'
      })
    },
    initValues () {
      this.dataId = null
      this.dataTag = null
    },
    submitData () {
      this.$validator.validateAll().then(result => {
        if (result) {
          if (this.dataId !== null && this.dataId >= 0) {
            this.$apollo
              .mutate({
                mutation: ADD_TEMPLATE_TAG,
                variables: {
                  id:this.dataId,  
                  tag:  this.dataTag
                }
              })
              .then(response => {
                if (response.data.addTemplateTag.status == 'Success') {
                  this.StatusSuccess(response.data.addTemplateTag.message)
                  this.$emit('closeSidebar')
                  this.initValues()
                  this.$emit('getdata')
                } else {
                  this.StatusFail()
                }
              }).catch(error => {
                console.log(error)
                this.StatusFail()
              })
          }
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.add-new-data-sidebar {
  ::v-deep .vs-sidebar--background {
    z-index: 52010;
  }

  ::v-deep .vs-sidebar {
    z-index: 52010;
    width: 400px;
    max-width: 90vw;

    .img-upload {
      margin-top: 2rem;

      .con-img-upload {
        padding: 0;
      }

      .con-input-upload {
        width: 100%;
        margin: 0;
      }
    }
  }
}

.scroll-area--data-list-add-new {
    // height: calc(var(--vh, 1vh) * 100 - 4.3rem);
    height: calc(var(--vh, 1vh) * 100 - 16px - 45px - 82px);

    &:not(.ps) {
      overflow-y: auto;
    }
}
</style>
